import React from "react"

function Title(props) {
    return(
        <div>
            <div><h1 className="title">Shanghai Coffee</h1><br/></div>
            <div>
                <p className="description">Give us some tips on how to improve your coffee time ;-)</p>
            </div><br/><br/>
        </div>
        
    )
}

export default Title